import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon'
import { MdDoneAll } from 'react-icons/md';
import { FaSpinner } from 'react-icons/fa';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 15,
    [theme.breakpoints.down('sm')]: {
      top: 10,
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: `linear-gradient(101.47deg, #0DF0B0 -29.45%, #1AA0C1 70.76%)`,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: `linear-gradient(101.47deg, #0DF0B0 -29.45%, #1AA0C1 70.76%)`,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    [theme.breakpoints.down('sm')]: {
      height: 2,
      minWidth: 30,
    },
  },
}));

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 30,
  height: 30,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    width: 20,
    height: 20,
  },
  ...(ownerState.active && {
    backgroundImage: `linear-gradient(101.47deg, #0DF0B0 -29.45%, #1AA0C1 70.76%)`,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage: `linear-gradient(101.47deg, #0DF0B0 -29.45%, #1AA0C1 70.76%)`,
  }),
}));



const steps = ['Upcoming', 'Quiz', 'Contribution', 'Vesting', 'Completed'];

export default function CustomizedSteppers({ activeStep }: { activeStep: number }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;
  
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {completed ? <MdDoneAll size={ isSmallScreen ? 12 : 18} /> : active ? <FaSpinner size={ isSmallScreen ? 12 : 18} /> : null}
      </ColorlibStepIconRoot>
    );
  }

  return (
    <Stack
      sx={{
        width: '100%',
        marginTop: '1rem',
        '& .MuiStepLabel-label': {
          typography: 'body2',
          [theme.breakpoints.down('sm')]: {
            fontSize: '0.75rem',
          },
        },
      }}
      spacing={isSmallScreen ? 2 : 4}
    >
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
        sx={{
          '& .MuiStep-root': {
            paddingLeft: isSmallScreen ? 0.5 : 1,
            paddingRight: isSmallScreen ? 0.5 : 1,
          },
        }}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}
